import { paddingUtil } from "@gadgetinc/themes/src/utils";
import { useStyletron } from "baseui";
import { merge } from "lodash";
import React, { forwardRef } from "react";
import type { ButtonProps } from "../../editor/Button";
import { Button, KIND, SIZE } from "../../editor/Button";

export const EntryButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const [_css, $theme] = useStyletron();
  const focusStyle = { backgroundColor: $theme.colors.primary300 };
  return (
    <Button
      kind={KIND.tertiary}
      size={SIZE.compact}
      ref={ref}
      {...props}
      overrides={merge(
        {
          BaseButton: {
            style: {
              ...paddingUtil($theme.sizing.scale100),
              ":focus-visible": focusStyle,
              ":hover": focusStyle,
            },
          },
        },
        props.overrides
      )}
    />
  );
});
